type OrganizationQueryType = 'users' | 'organization';

export const ORGANIZATION_QUERY_KEY = {
  organization: 'organization' as OrganizationQueryType,
  users: 'users' as OrganizationQueryType,
};
